import { render, staticRenderFns } from "./FooterClover.vue?vue&type=template&id=047718f0"
import script from "./FooterClover.vue?vue&type=script&lang=js"
export * from "./FooterClover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports